import * as React from "react";

export const Folder = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6875 4.33333C14.3984 4.33333 15 4.96354 15 5.70833V12.125C15 12.8984 14.3984 13.5 13.6875 13.5H2.3125C1.57422 13.5 1 12.8984 1 12.125V3.875C1 3.13021 1.57422 2.5 2.3125 2.5H6.6875L8.4375 4.33333H13.6875Z"
    />
);
